var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2 86.6c-2.4 0-4.8-1-6.5-2.7L6.6 62.7c-3.4-3.4-3.4-9.1.2-12.7L9 47.9c3.4-3.4 9.3-3.5 12.7-.2l12.5 12.5L78.4 16c4.6-4.6 10.3-2.2 12.7.2l2.2 2.2c1.7 1.7 2.7 4 2.7 6.5 0 2.4-.9 4.5-2.5 6.2L40.4 84c-1.6 1.7-3.8 2.6-6.2 2.6z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBmaWxsPSJub25lIj48cGF0aCBkPSJNMzQuMiA4Ni42Yy0yLjQgMC00LjgtMS02LjUtMi43TDYuNiA2Mi43Yy0zLjQtMy40LTMuNC05LjEuMi0xMi43TDkgNDcuOWMzLjQtMy40IDkuMy0zLjUgMTIuNy0uMmwxMi41IDEyLjVMNzguNCAxNmM0LjYtNC42IDEwLjMtMi4yIDEyLjcuMmwyLjIgMi4yYzEuNyAxLjcgMi43IDQgMi43IDYuNSAwIDIuNC0uOSA0LjUtMi41IDYuMkw0MC40IDg0Yy0xLjYgMS43LTMuOCAyLjYtNi4yIDIuNnoiLz48L3N2Zz4=";
export { SvgOk as ReactComponent };